import React from 'react';
import { useTabContext } from '@mui/lab';

export function TabPanel(props) {
  const {
    children,
    className,
    style,
    value: id,
    ...other
  } = props;

  const context = useTabContext();

  if (context === null) {
    throw new TypeError('No TabContext provided');
  }
  const tabId = context.value;

  // We need to keep tabs in DOM
  // That's why we just sending them away instead of unmounting

  return (
    <div
      className={className}
      style={{
        width: '97.5%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '48px',
        transform: id === tabId ? 'none' : 'translate(-5000px, 0)',
        position: 'absolute',
        ...style,
      }}
      {...other}
    >
      {children}
    </div>
  );
}
